import {
    AvailableProgramList,
    FetchAllProgramsParams,
    FetchProgramByIDResponse,
    ProgramsListAPIResponse,
    ProgramTypeList,
    SaveProgramAPIPayload,
} from '../components/Programs/interfaces'
import { ApiCommonResponse } from '../interfaces/Interfaces'
import { axiosInstance, axiosInstanceEntity } from './axiosInstance'
import { showErrorToster, showSuccessToster } from './utils'

export const fetchPrograms = async (
    orgId: string,
    params: FetchAllProgramsParams,
): Promise<ProgramsListAPIResponse> => {
    return await axiosInstance
        .get(`/program`, { params })
        .then((response) => {
            return response.data
        })
        .catch(() => {
            return null
        })
}

export const saveProgram = async (
    programId: string | null,
    data: SaveProgramAPIPayload,
): Promise<ApiCommonResponse<any>> => {
    return await axiosInstance
        .post(`/program`, data, { params: { programId } })
        .then((response) => {
            showSuccessToster(response)
            return { success: true, payload: response.data }
        })
        .catch((error) => {
            showErrorToster(error)
            return { success: false, payload: error }
        })
}

export const fetchProgramByID = async (
    programId: string | null,
): Promise<FetchProgramByIDResponse> => {
    return await axiosInstance
        .get(`/program/data`, { params: { programId } })
        .then((response) => {
            return response.data
        })
        .catch(() => {
            return null
        })
}

export const deleteProgram = async (programId: string): Promise<any> => {
    return await axiosInstance
        .delete(`/program/data`, { params: { programId } })
        .then((response) => {
            showSuccessToster(response)
            return response.data
        })
        .catch((error) => {
            showErrorToster(error)
            return null
        })
}

export const fetchProgramTypes = async (): Promise<ProgramTypeList[]> => {
    return await axiosInstance
        .get(`/program/programTypes`)
        .then((response) => {
            return response.data
        })
        .catch(() => {
            return []
        })
}

export const fetchAvaliblePrograms = async (
    orgId: string,
): Promise<AvailableProgramList[]> => {
    return await axiosInstanceEntity
        .get(`/entity/programs?orgId=${orgId}`)
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}
